import { useQuery } from '@tanstack/react-query'

import { getTraderProfile } from '@/lib/services/trader.service'

// Query keys for React Query
export const traderProfileKeys = {
  all: ['traderProfile'] as const,
  profile: (address: string) => [...traderProfileKeys.all, 'profile', address] as const,
}

/**
 * Hook to fetch trader profile data by address
 * @param address - The trader's wallet address
 * @param options - Additional query options
 * @returns useQuery result with trader profile data
 */
export function useTraderProfile(address: string) {
  return useQuery({
    queryKey: traderProfileKeys.profile(address),
    queryFn: () => getTraderProfile(address),
    enabled: !!address,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 3,
    refetchOnWindowFocus: false,
  })
}
